
import { TableColumn } from '@/models/TableColumn'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Pagination from '@/components/Pagination/Pagination.vue'

@Component({ 
  components:{
    Pagination
  }
})
export default class PaginatedTable extends Vue {
  @Prop({ default: '' })
  emptyMsg!: string;

  @Prop()
  columns!: TableColumn[];

  @Prop({ default: () => ([]) })
  data!: { [key: string]: string | { value: string; sortValue: string}}[];

  selectedAll = false;

  getSelectedAll() { 
    this.selectedAll = this.selected.length === this.data.length;
  }

  indexedData: { [key: string]: string | { value: string; sortValue: string}}[] = [];

  selected: number[] = [];
  expanded: number[] = [];

  toggleExpand(data:  { [key: string]: string | { value: string; sortValue: string}}, index: number){ 
    if (this.expanded.includes(index)){ 
      this.expanded.splice(this.expanded.findIndex(r => r === index), 1);
      this.$emit('toggle', data, index, false);
    }else{ 
      this.expanded.push(index);
      this.$emit('toggle', data, index, true);
    }
  }

  toggleAll() {     
    if (!this.selectedAll){ 
      this.selected = [];
      for (let i = 0; i < this.data.length; i++) {
        this.selected.push(i);
      }
    }else{ 
      this.selected = [];
    }
    this.$forceUpdate();
    this.getSelectedAll();
  }

  onSelect() {
    setTimeout(()=>{
      this.getSelectedAll();
    }, 25);
  }

  @Watch('data')
  indexData() {
    this.indexedData = this.data.map((r, index) => (Object.assign({
      index
    }, r)))
  }

  mounted() { 
    this.indexData();
  }

}
